import { Link } from 'react-router-dom';
import { featuredComics } from '@/mocks/comics';

function FeaturedSection() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-10">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-2">
              热门推荐
            </h2>
            <p className="text-sm text-foreground-600">
              千万读者共同选择，不容错过的经典之作
            </p>
          </div>
          <Link
            to="/category/romance"
            className="hidden sm:flex items-center gap-1.5 text-sm text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6">
          {featuredComics.slice(0, 8).map((comic) => (
            <Link
              key={comic.id}
              to={`/article/${comic.id}`}
              className="group cursor-pointer"
            >
              <div className="relative aspect-[3/4] rounded-xl overflow-hidden mb-3 bg-background-100">
                <img
                  src={comic.cover}
                  alt={comic.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  title={`${comic.title} - 韩漫之家高清韩国漫画`}
                />
                <div className="absolute top-2.5 left-2.5 flex flex-col gap-1.5">
                  {comic.isHot && (
                    <span className="px-2 py-0.5 bg-primary-500 text-background-50 text-xs rounded-md font-medium">
                      热门
                    </span>
                  )}
                  {comic.isNew && (
                    <span className="px-2 py-0.5 bg-accent-500 text-background-50 text-xs rounded-md font-medium">
                      新作
                    </span>
                  )}
                </div>
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/60 to-transparent pt-8 pb-3 px-3">
                  <div className="flex items-center gap-1 text-background-50 text-xs">
                    <i className="ri-star-fill text-accent-400 text-xs"></i>
                    <span>{comic.rating}</span>
                  </div>
                </div>
              </div>
              <h3 className="font-heading text-sm font-bold text-foreground-950 group-hover:text-primary-500 transition-colors line-clamp-1 mb-1">
                {comic.title}
              </h3>
              <p className="text-xs text-foreground-500">
                {comic.author} · 更新至{comic.chapters}话
              </p>
            </Link>
          ))}
        </div>

        <div className="mt-8 text-center sm:hidden">
          <Link
            to="/category/romance"
            className="inline-flex items-center gap-1.5 text-sm text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}

export default FeaturedSection;